import { Link } from "react-router-dom";

function MainFooter() {
    const socialLink = [
        
    ];
    return ( 
        <footer className=" p-3 text-center">
            <div className="copyrighttext">
                © Copyright reserved. All Rights Reserved.
            </div>

        </footer>
     );
}

export default MainFooter;